module.exports = __webpack_public_path__ + "img/code.f48eb373.png";